import React, { useState, useEffect } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';

// @material-ui/icons
import Email from '@material-ui/icons/Email';
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import CustomInput from 'components/CustomInput/CustomInput.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardFooter from 'components/Card/CardFooter.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.js';
import { Toasty, useToasty } from 'hooks/Toasty';

import { useApp } from 'hooks/useApp';
import { useMounted } from 'hooks/useMounted';
import { useAuth } from 'hooks/useAuth';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { TextField } from '@material-ui/core';
import { useModal } from 'hooks/useModal';
import ReCAPTCHA from 'react-google-recaptcha';

const useStyles = makeStyles(styles);

const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;

const TwoFactorModal = (props) => {
  const { model, setOpen, onSubmit } = props;
  const { authKey, setAuthKey } = props;

  return (
    <ModalBase
      title="Autenticación de 2 factores"
      model={model}
      setOpen={setOpen}
      disabledSave
      hideSave
      minWidth="xl"
    >
      <TextField
        label="Código"
        fullWidth
        value={authKey}
        onChange={(e) => setAuthKey(e.target.value)}
      />
      <Button color="success" onClick={onSubmit} disabled={authKey.length !== 6}>
        Acceder
      </Button>
    </ModalBase>
  );
};

export default function LoginPage() {
  const classes = useStyles();
  const mounted = useMounted();
  const app = useApp();
  const { login } = useAuth();

  const [cardAnimaton, setCardAnimation] = useState('cardHidden');
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [notify, showNotify] = useToasty();

  const [model, setOpen] = useModal();
  const [authKey, setAuthKey] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.id]: e.target.value,
    });
  };

  function onCaptchaChange(value) {
    setCaptchaValue(value);
  }

  useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation('');
    }, 700);

    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  }, []);

  async function handleSubmit(e) {
    if (!!e) e.preventDefault();
    try {
      const userData = await login(loginData.username, loginData.password, captchaValue, authKey);
      if (!!userData && userData['2fa_error'] === true) {
        setOpen({ open: true });
        return;
      }
      if (mounted.current) {
        showNotify(`Bienvenido ${userData.message}`);
      }
    } catch (err) {
      if (mounted.current) {
        console.log(err.response);
        if(!!err.response?.data?.message){
          showNotify(`${err.response?.data?.message}`, 'error');
        }else{
          showNotify(`Error de inicio de session ${err.message}`, 'error');
        }
      }
    }
  }

  return (
    <div className={classes.container}>
      <GridContainer justifyContent="center">
        <TwoFactorModal
          model={model}
          setOpen={setOpen}
          authKey={authKey}
          setAuthKey={setAuthKey}
          onSubmit={handleSubmit}
        />
        <Toasty action={notify} />
        <GridItem xs={12} sm={6} md={4}>
          <form onSubmit={handleSubmit}>
            <Card login className={classes[cardAnimaton]}>
              <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color="primary">
                <h4 className={classes.cardTitle}>{app.name}</h4>

                <div className={classes.socialLine}>
                  {['fab fa-facebook-square', 'fab fa-twitter', 'fab fa-google-plus'].map(
                    (prop, key) => {
                      return (
                        <Button
                          color="transparent"
                          justIcon
                          key={key}
                          className={classes.customButtonClass}
                        >
                          <i className={prop} />
                        </Button>
                      );
                    },
                  )}
                </div>
              </CardHeader>
              <CardBody>
                <CustomInput
                  labelText="Email..."
                  id="username"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: handleChange,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
                <CustomInput
                  labelText="Contraseña"
                  id="password"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: handleChange,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon className={classes.inputAdornmentIcon}>lock_outline</Icon>
                      </InputAdornment>
                    ),
                    type: 'password',
                    autoComplete: 'off',
                  }}
                />
                {CAPTCHA_KEY !== undefined && (
                  <ReCAPTCHA sitekey={CAPTCHA_KEY} onChange={onCaptchaChange} />
                )}
              </CardBody>
              <CardFooter className={classes.justifyContentCenter}>
                <Button
                  color="primary"
                  round
                  size="lg"
                  block
                  type="submit"
                  variant="outlined"
                  disabled={CAPTCHA_KEY === undefined ? false : captchaValue.length === 0}
                >
                  Ingresar
                </Button>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
